var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginVactor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 606,
    viewBox: "0 0 655 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.766 573.91C441.766 573.91 334.804 571.114 231.054 575.323C127.291 579.532 76.0623 588.025 31.9924 594.825C-12.091 601.625 15.2095 608.605 95.5646 611.849C175.906 615.092 229.334 610.464 341.229 610.336C453.123 610.208 483.423 611.376 575.496 606.946C667.581 602.516 682.485 591.874 607.822 583.924C533.145 575.974 441.766 573.91 441.766 573.91Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M441.766 573.91C441.766 573.91 334.804 571.114 231.054 575.323C127.291 579.532 76.0623 588.025 31.9924 594.825C-12.091 601.625 15.2095 608.605 95.5646 611.849C175.906 615.092 229.334 610.464 341.229 610.336C453.123 610.208 483.423 611.376 575.496 606.946C667.581 602.516 682.485 591.874 607.822 583.924C533.145 575.974 441.766 573.91 441.766 573.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.88 43.8084H451.026V149.354H502.88V43.8084Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.109 43.8084H509.255V149.354H561.109V43.8084Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.338 43.8084H567.484V149.354H619.338V43.8084Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.88 154.814H451.026V260.36H502.88V154.814Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.109 154.814H509.255V260.36H561.109V154.814Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.338 154.814H567.484V260.36H619.338V154.814Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.88 265.82H451.026V371.365H502.88V265.82Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.109 265.82H509.255V371.365H561.109V265.82Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.338 265.82H567.484V371.365H619.338V265.82Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.88 376.826H451.026V482.371H502.88V376.826Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.109 376.826H509.255V482.371H561.109V376.826Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.338 376.826H567.484V482.371H619.338V376.826Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 493.348H666",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.517 362.021H227.891V392.531H235.517V362.021Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.256 362.021H345.629V392.531H353.256V362.021Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.594 262.358H333.949C339.55 262.358 344.095 266.903 344.095 272.504V405.661H234.448V272.504C234.448 266.903 238.993 262.358 244.594 262.358Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.331 527.91C242.486 527.91 245.044 525.352 245.044 522.197C245.044 519.041 242.486 516.483 239.331 516.483C236.176 516.483 233.618 519.041 233.618 522.197C233.618 525.352 236.176 527.91 239.331 527.91Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.097 522.197C295.097 519.045 292.536 516.483 289.384 516.483C286.232 516.483 283.671 519.045 283.671 522.197C283.671 525.349 286.232 527.91 289.384 527.91C292.536 527.91 295.097 525.349 295.097 522.197Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.15 522.197C345.15 519.045 342.589 516.483 339.437 516.483C336.285 516.483 333.724 519.045 333.724 522.197C333.724 525.349 336.285 527.91 339.437 527.91C342.589 527.91 345.15 525.349 345.15 522.197Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.548 493.474V399.215H284.501V492.869L284.135 493.123L232.182 514.091V520.297H240.288V516.005L285.303 509.377L286.133 520.297H292.142L292.972 509.447L337.523 516.005V520.297H345.629V514.091L294.548 493.474Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.215 409.643H273.314V420.944H305.215V409.643Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.203 385.058H229.326C227.196 385.058 225.47 386.784 225.47 388.914V406.449C225.47 408.578 227.196 410.305 229.326 410.305H349.203C351.332 410.305 353.059 408.578 353.059 406.449V388.914C353.059 386.784 351.332 385.058 349.203 385.058Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.366 344.374H222.023C220.258 344.374 218.828 345.804 218.828 347.568V364.54C218.828 366.304 220.258 367.735 222.023 367.735H231.366C233.13 367.735 234.56 366.304 234.56 364.54V347.568C234.56 345.804 233.13 344.374 231.366 344.374Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.028 344.374H346.684C344.92 344.374 343.49 345.804 343.49 347.568V364.54C343.49 366.304 344.92 367.735 346.684 367.735H356.028C357.792 367.735 359.222 366.304 359.222 364.54V347.568C359.222 345.804 357.792 344.374 356.028 344.374Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.413 381.61L455.839 381.61V348.68L117.413 348.68V381.61Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.413 357.433L455.839 357.433V348.68L117.413 348.68V357.433Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.264 527.924H457.063L458.653 348.202H450.66L452.264 527.924Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.711 527.924H120.509L122.113 348.202H114.12L115.711 527.924Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.66 351.312L463.508 351.312V343.881L109.66 343.881V351.312Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.031 344.318H350.498V339.927H244.031V344.318Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.576 324.208H454.671V237.886H326.576V324.208Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.241 344.318H406.081V339.448H354.241V344.318Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.179 344.318H406.081V288.435H375.179V344.318Z",
    fill: "#ABABAB",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.999 50.7744L293.437 54.377",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.457 21.8972L306.678 31.5229",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.886 50.7744L373.448 54.377",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.429 21.8972L360.207 31.5229",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.343 9.25986V21.292",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.092 77.977L344.151 59.7669C344.151 59.7669 342.674 47.4392 342.674 43.3863C342.674 39.3333 341.196 38.9674 340.647 39.7133L338.987 40.628C338.987 40.628 338.438 35.8433 336.96 37.3209C335.483 38.7985 335.3 40.8109 335.3 40.8109C335.3 40.8109 333.64 43.7521 332.908 47.4392C332.598 48.9731 332.359 51.4359 332.176 53.8282L331.247 52.5898C331.247 52.5898 330.699 46.5245 330.516 45.2298C330.333 43.9351 328.306 45.4127 328.123 50.0145C327.983 53.6031 330.079 62.8066 331.008 66.6626C330.516 70.7999 330.079 75.9506 330.699 78.3429C331.796 82.5788 334.005 85.3371 334.751 86.4347C335.497 87.5324 339.902 99.4942 339.902 99.4942L353.143 93.6118L347.078 77.977H347.092Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.125 70.617C342.125 70.617 338.255 63.4399 337.523 62.1593C336.792 60.8646 332.373 55.531 331.261 52.5898C330.164 49.6486 327.589 53.6875 328.686 56.8257C329.784 59.9499 334.202 65.6634 334.202 65.6634C334.202 65.6634 332.725 70.6311 334.751 74.867C336.778 79.1029 340.816 80.9323 340.816 80.9323",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.125 70.617C342.125 70.617 338.255 63.4399 337.523 62.1593C336.792 60.8646 332.373 55.531 331.261 52.5898C330.164 49.6486 327.589 53.6875 328.686 56.8257C329.784 59.9499 334.202 65.6634 334.202 65.6634C334.202 65.6634 332.725 70.6311 334.751 74.867C336.778 79.1029 340.816 80.9323 340.816 80.9323",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.987 40.628C338.987 40.628 337.692 54.9822 338.255 60.4987",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.314 40.8109C335.314 40.8109 334.02 52.2239 334.765 57.0087",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.497 172.349C444.497 172.349 421.827 164.454 420.307 164.454C418.788 164.454 402.915 163.314 402.915 163.314L384.143 153.505L353.889 92.0779L336.06 100.733C336.06 100.733 342.42 133.592 347.514 151.676C352.608 169.759 358.42 180.173 358.42 180.173L398.904 210.303L400.945 213.103L444.497 172.349Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.33 246.723C380.33 246.723 371.929 283.397 371.929 303.014C371.929 322.631 372.435 327.726 373.716 328.486C374.982 329.246 389.504 331.793 390.785 331.54C392.065 331.286 395.879 330.006 395.879 330.006C395.879 330.006 414.468 241.882 416.508 230.934C418.548 219.985 421.349 196.047 421.349 196.047C421.349 196.047 399.96 214.384 394.092 220.759C388.224 227.134 388.745 227.387 386.198 232.214C383.651 237.041 380.344 246.737 380.344 246.737L380.33 246.723Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.025 526.855C390.025 526.855 383.2 538.141 382.004 539.323C380.808 540.506 370.423 546.754 367.454 547.64C364.485 548.527 361.22 550.314 361.22 553.284C361.22 556.253 371.014 557.745 376.066 557.745C381.118 557.745 395.963 556.858 397.736 556.858C399.509 556.858 402.788 556.563 404.266 556.858C405.757 557.154 413.173 558.35 415.256 557.449C417.338 556.563 419.111 549.132 418.52 545.867C417.929 542.602 416.142 535.172 416.142 535.172L390.011 526.855H390.025Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.886 538.141L475.835 546.458C475.835 546.458 469.193 552.439 465.436 554.775C456.331 560.461 469.305 563.796 475.229 563.388C479.395 563.106 487.106 563.092 489.484 561.896C491.862 560.714 501.656 554.17 505.526 551.201C509.382 548.231 509.677 544.967 509.086 541.111C508.495 537.255 505.821 531.316 505.821 531.316C505.821 531.316 490.089 526.264 485.628 529.824C481.168 533.385 480.872 538.141 480.872 538.141H480.886Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.824 321.407L387.084 356.8C387.084 356.8 375.292 430.626 375.63 433.314C375.967 436.016 390.138 512.262 390.475 515.287C390.813 518.313 387.436 521.353 387.436 521.353L388.111 528.769C388.111 528.769 396.54 534.496 402.267 535.847C407.995 537.198 416.761 537.536 416.761 537.536C416.761 537.536 419.801 531.133 419.801 530.12C419.801 529.107 417.774 522.366 417.774 521.353C417.774 520.339 412.371 431.287 412.371 431.287L425.514 380.386C425.514 380.386 443.385 434.313 445.06 438.028C446.748 441.729 479.254 524.125 479.254 524.125C479.254 524.125 476.214 528.164 477.228 531.203C478.241 534.243 479.592 539.971 479.592 539.971C479.592 539.971 487.007 531.541 490.708 534.243C494.409 536.945 495.085 539.971 495.085 539.971L506.877 535.256C506.877 535.256 507.89 530.542 507.214 528.178C506.539 525.814 504.85 528.853 504.85 520.086C504.85 511.319 493.241 458.926 490.877 450.848C488.513 442.756 478.747 427.586 478.747 427.586L474.371 346.006V327.135L393.81 321.407H393.824Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.505 176.458C450.505 176.458 441.809 173.7 438.263 175.276C434.717 176.852 405.546 207.826 405.152 209.796C404.758 211.766 390.292 308.699 387.928 316.172C385.564 323.645 398.552 333.102 398.552 333.102L406.419 336.648L413.103 328.781L412.709 338.224C412.709 338.224 433.169 338.618 439.473 337.83C445.763 337.042 470.164 330.751 470.164 330.751C470.164 330.751 475.286 245.738 475.68 244.162C476.074 242.586 480.014 188.673 480.014 188.673L472.542 183.945L450.505 176.472V176.458Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.393 199.988L455.895 210.993C455.895 210.993 471.88 193.697 473.71 189.503C475.539 185.31 477.115 185.042 476.074 182.425C475.032 179.807 472.401 177.19 472.401 177.19C472.401 177.19 448.029 176.402 444.891 177.978C441.753 179.554 433.099 199.2 432.578 200.522L432.057 201.831L448.563 198.946L450.393 199.988Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.977 178.724C442.977 178.724 388.984 228.893 386.183 232.214C383.383 235.535 380.33 246.737 380.33 246.737C380.33 246.737 385.17 225.347 386.957 222.026C388.745 218.718 426.935 179.498 426.935 179.498L437.123 172.363L447.564 174.91L442.977 178.724Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.817 111.146C448.817 111.146 438.066 122.419 438.333 124.516C438.601 126.612 438.066 129.497 438.066 129.497C438.066 129.497 426.794 138.673 425.753 138.926C424.712 139.193 424.712 141.023 425.486 142.599C426.274 144.175 427.582 144.428 428.103 145.737C428.624 147.046 428.37 150.719 426.274 158.051C424.177 165.383 423.136 166.438 425.232 167.747C427.329 169.056 442.527 174.305 442.527 174.305C442.527 174.305 443.047 196.315 444.103 199.467C445.144 202.605 450.393 199.988 450.393 199.988L472.401 179.019V175.346L489.695 154.645C489.695 154.645 494.409 137.617 489.174 129.483C483.94 121.363 456.415 109.824 455.627 109.57C454.839 109.303 451.167 108.782 448.817 111.146Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.954 104.603C467.954 104.603 472.415 101.985 469.53 100.676C466.646 99.3676 463.508 100.409 462.72 100.676C461.932 100.944 463.508 92.8097 459.047 95.1739C454.586 97.5381 448.831 103.294 447.522 107.234C446.213 111.175 450.14 118.76 453.545 119.295C456.95 119.815 464.549 122.433 464.549 122.433C464.549 122.433 466.646 124.009 465.337 126.894C464.028 129.779 456.43 135.549 457.471 137.111C458.512 138.687 461.144 142.346 461.144 142.346C461.144 142.346 458.526 147.06 459.047 148.369C459.568 149.678 461.144 150.198 461.144 150.198C461.144 150.198 465.858 147.313 469.798 148.369C473.738 149.424 472.162 155.968 470.586 158.853C469.01 161.738 466.913 165.144 466.913 165.144C466.913 165.144 471.374 175.36 472.415 175.36C473.456 175.36 486.304 162.526 491.806 156.756C497.308 150.986 499.672 141.037 498.363 132.65C497.055 124.262 483.166 112.99 478.705 110.372C474.244 107.755 467.954 104.603 467.954 104.603Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.002 133.958C428.638 132.382 430.481 125.05 432.578 124.262C434.675 123.474 438.08 129.497 438.08 129.497C438.08 129.497 449.351 138.152 449.605 139.714C449.872 141.29 443.582 146.005 440.177 146.272C436.771 146.539 435.463 146.539 435.463 141.558C435.463 136.576 437.292 133.17 437.292 133.17",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.605 139.714L463.761 149.41",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.794 129.497C442.794 129.497 448.029 130.018 450.125 134.732",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.481 152.295C430.481 152.295 435.195 154.392 440.697 152.295",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.899 165.144C466.899 165.144 461.397 166.452 458.78 165.144",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.527 174.305L452.489 173.784L442.794 182.96L442.527 174.305Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.074 182.439C476.074 182.439 470.797 191.516 465.661 209.627C460.524 227.753 455.121 282.651 455.121 288.604C455.121 294.556 468.911 365.947 469.995 368.649C471.078 371.351 477.833 371.619 477.833 371.619C477.833 371.619 497.843 358.095 498.926 354.309C500.01 350.524 486.219 286.971 486.219 286.971C486.219 286.971 511.366 204.758 509.747 203.675C508.129 202.591 476.088 182.439 476.088 182.439H476.074Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.403 191.502C485.403 191.502 468.644 258.572 464.577 270.196C460.524 281.821 455.107 288.59 455.107 288.59",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.803 360.037C479.803 360.037 477.27 363.935 475.905 365.483C474.54 367.045 470.839 368.79 472.598 369.958C474.357 371.126 479.015 368.987 480.183 367.228L479.789 360.023L479.803 360.037Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.413 344.937C490.413 344.937 480.197 354.788 479.62 355.759C479.043 356.73 478.452 364.906 478.452 367.242C478.452 369.578 480.014 370.943 480.788 371.14C481.562 371.337 483.124 371.337 483.124 371.337L485.657 370.943C485.657 370.943 487.993 370.746 490.328 371.337C492.664 371.914 497.336 371.914 498.504 370.76C499.672 369.592 500.84 366.679 500.84 366.679C500.84 366.679 502.205 365.117 502.585 362.781C502.979 360.445 505.315 348.765 505.315 348.765C505.315 348.765 488.767 343.079 490.427 344.951L490.413 344.937Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.11 371.323L484.869 360.431",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.176 370.746L490.117 361.402",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.015 371.126L495.76 362.373",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.733 203.675C509.733 203.675 537.3 264.652 541.085 274.123C544.871 283.594 541.901 287.013 541.085 289.448C540.269 291.883 509.058 350.876 509.058 350.876L490.399 344.923L509.621 283.073L495.394 256.124L509.733 203.661V203.675Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.052 97.3129C360.052 97.3129 360.235 89.9388 361.572 85.5763C362.895 81.2278 361.952 79.328 361.009 79.708C360.066 80.0879 358.927 80.2709 358.364 83.6765C357.801 87.0821 357.604 88.7849 357.604 90.8676C357.604 92.9504 360.066 97.2989 360.066 97.2989L360.052 97.3129Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.606 75.8098C339.944 75.2188 342.097 77.5408 343.588 78.9058C342.997 77.6956 342.843 77.6252 341.886 75.5424C340.746 73.0797 340.957 71.6584 341.126 70.9969C341.632 69.0268 345.671 73.4034 346.853 75.6832C346.248 73.8537 345.01 70.0541 344.728 68.9142C344.348 67.3943 344.545 65.3256 345.671 64.5657C346.811 63.8058 348.513 67.7883 348.513 67.7883C348.513 67.7883 350.976 68.9282 351.919 70.814L358.35 83.6765L358.913 92.7534L364.78 115.087L378.402 134.015L363.373 141.318L354.564 120.392C354.564 120.392 352.299 118.506 350.596 115.847C349.358 113.919 348.218 106.77 347.543 100.986C347.205 100.029 346.712 98.481 346.389 96.5671C345.84 93.3444 344.841 85.8015 344.841 85.8015C344.841 85.8015 341.956 82.3536 340.394 80.0316C339.479 78.6525 339.17 76.5838 339.62 75.8098H339.606Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.191 76.6823C347.191 76.6823 349.78 80.7353 350.723 83.0291C351.497 84.9149 352.172 87.6872 352.172 87.6872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.513 67.7884C348.513 67.7884 353.439 79.328 354.564 81.0308C355.704 82.7336 356.267 86.3362 356.267 87.2791",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.602 78.9058C343.602 78.9058 347.275 82.3536 347.725 83.3528C348.176 84.352 349.611 89.7981 349.611 89.7981",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.804 463.542C462.804 463.542 464.718 490.167 462.086 503.114C459.455 516.061 449.858 535.242 448.901 537.888C447.944 540.52 439.783 570.016 440.022 571.226C440.261 572.437 446.017 582.738 445.299 587.776C444.581 592.814 443.385 594.249 441.218 594.728C439.065 595.206 428.751 594.967 421.799 600.723C414.848 606.478 404.533 605.282 400.931 605.043C397.328 604.804 387.985 604.804 387.506 602.89C387.028 600.976 392.544 596.656 395.415 595.46C398.285 594.263 405.968 587.79 408.121 585.623C410.274 583.456 418.436 572.915 420.111 568.834C421.785 564.753 426.583 502.411 428.019 492.813C429.454 483.215 430.411 472.436 430.172 466.441C429.933 460.446 431.368 457.082 431.368 457.082L462.776 463.556L462.804 463.542Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.429 595.445C396.498 594.995 398.215 593.827 400.072 592.434C402.085 593.335 404.899 594.489 406.222 594.489C408.375 594.489 424.205 583.934 429.721 580.824C434.196 578.305 440.543 577.658 442.794 577.517C444.258 581.007 445.693 585.13 445.313 587.79C444.595 592.828 443.399 594.263 441.232 594.742C439.079 595.22 428.765 594.981 421.813 600.737C414.862 606.493 404.547 605.296 400.945 605.057C397.342 604.818 387.999 604.818 387.52 602.904C387.042 600.99 392.558 596.67 395.429 595.474V595.445Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.296 456.477C541.296 456.477 549.753 471.141 553.412 485.509C557.071 499.892 556.508 561.347 557.071 562.473C557.634 563.599 562.713 575.448 565.246 580.514C567.779 585.595 573.985 593.194 573.985 595.46C573.985 597.725 569.468 597.711 568.624 597.711H553.117C553.117 597.711 548.895 596.304 548.037 594.615C547.192 592.926 546.63 585.595 544.659 583.343C542.689 581.091 537.891 575.167 537.61 572.071C537.328 568.975 539.298 559.391 539.298 557.125C539.298 554.86 533.092 529.782 531.122 523.295C529.152 516.807 519.288 499.892 518.148 485.805C517.008 471.718 515.897 465.512 515.897 465.512L541.268 456.491L541.296 456.477Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.062 559.405C554.256 560.334 557.057 563.726 558.633 565.935C560.476 570.129 563.487 576.968 565.26 580.514C567.793 585.595 573.999 593.194 573.999 595.46C573.999 597.725 569.482 597.711 568.638 597.711H553.131C553.131 597.711 548.909 596.304 548.051 594.615C547.206 592.926 546.643 585.595 544.673 583.343C542.703 581.091 537.905 575.167 537.624 572.071C537.455 570.227 538.088 566.104 538.623 562.586C539.495 561.713 544.223 557.421 551.048 559.419L551.062 559.405Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.652 597.711H553.145C553.145 597.711 548.923 596.304 548.065 594.615C547.22 592.926 546.658 585.595 544.688 583.343C543.027 581.443 539.368 576.954 538.088 573.717L538.848 572.915C538.848 572.915 546.432 566.807 551.991 570.143C557.549 573.478 559.027 581.246 562.545 585.13C566.063 589.014 571.959 591.899 574.013 595.46C574.013 597.711 569.496 597.711 568.652 597.711Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.615 229.456C546.615 229.456 555.396 277.528 555.664 279.104C555.931 280.681 563.037 304.14 561.996 309.417C560.94 314.694 539.059 359.235 539.059 359.235C539.059 359.235 533.529 350.003 532.727 349.482C531.925 348.962 534.837 304.942 534.837 304.942L526.141 276.74C526.141 276.74 526.085 247.99 529.842 242.487C533.599 236.985 545.11 226.712 546.615 229.47V229.456Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.927 282.735C528.927 282.735 541.395 279.541 548.346 272.589",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.725 292.586C534.725 292.586 544.294 298.68 554.144 298.68",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.275 338.097C543.984 349.201 539.059 359.235 539.059 359.235C539.059 359.235 533.529 350.003 532.727 349.482C532.431 349.285 532.642 343.29 533.022 335.761C539.397 340.138 545.18 339.603 549.275 338.097Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.072 311.795C524.072 311.795 536.371 343.487 541.156 355.885C545.954 368.283 546.658 434.482 546.658 434.482L545.25 459.292C545.25 459.292 517.628 472.267 486.051 470.845C454.474 469.438 427.414 460.418 427.414 460.418C427.414 460.418 427.554 402.973 434.604 383.806C441.654 364.639 446.72 345.176 446.72 345.176L449.084 315.468L524.072 311.81V311.795Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.594 244.978C539.087 246.231 526.915 285.958 526.915 285.958C526.915 285.958 524.016 295.443 523.749 296.498C523.481 297.554 524.269 309.938 524.537 310.993C524.804 312.049 526.732 309.234 525.944 312.935C525.156 316.622 521.723 316.89 519.612 317.945C517.501 319.001 501.431 324.799 484.559 324.531C467.687 324.264 448.718 320.844 448.718 320.844C448.718 320.844 445.82 315.567 445.299 313.203C444.778 310.824 446.256 305.463 446.256 305.463L439.178 248.736C439.178 248.736 409.838 209.951 405.828 207.193C401.817 204.435 396.568 200.438 395.063 199.185C393.557 197.933 392.051 195.428 391.052 192.67C390.053 189.912 363.359 141.318 363.359 141.318C363.359 141.318 370.114 134.057 371.873 133.55C373.632 133.044 377.628 132.551 377.628 132.551L412.329 171.378C412.329 171.378 419.083 174.629 420.589 175.388C422.095 176.134 421.841 180.398 421.841 180.398L432.395 185.127L467.814 196.315L484.728 200.396C484.728 200.396 532.558 218.423 535.555 219.929C538.566 221.434 546.826 226.937 546.573 229.442C546.32 231.947 541.817 242.206 541.817 242.206",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.594 244.978C539.087 246.231 526.915 285.958 526.915 285.958C526.915 285.958 524.016 295.443 523.749 296.498C523.481 297.554 524.269 309.938 524.537 310.993C524.804 312.049 526.732 309.234 525.944 312.935C525.156 316.622 521.723 316.89 519.612 317.945C517.501 319.001 501.431 324.799 484.559 324.531C467.687 324.264 448.718 320.844 448.718 320.844C448.718 320.844 445.82 315.567 445.299 313.203C444.778 310.824 446.256 305.463 446.256 305.463L439.178 248.736C439.178 248.736 409.838 209.951 405.828 207.193C401.817 204.435 396.568 200.438 395.063 199.185C393.557 197.933 392.051 195.428 391.052 192.67C390.053 189.912 363.359 141.318 363.359 141.318C363.359 141.318 370.114 134.057 371.873 133.55C373.632 133.044 377.628 132.551 377.628 132.551L412.329 171.378C412.329 171.378 419.083 174.629 420.589 175.388C422.095 176.134 421.841 180.398 421.841 180.398L432.395 185.127L467.814 196.315L484.728 200.396C484.728 200.396 532.558 218.423 535.555 219.929C538.566 221.434 546.826 226.937 546.573 229.442C546.32 231.947 541.817 242.206 541.817 242.206",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.969 280.202C474.681 290.518 484.981 302.972 493.706 308.897",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.501 263.822C455.501 263.822 459.145 269.479 464.563 276.937",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.401 306.687C504.766 307.63 506.131 308.488 507.426 309.164",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.277 290.447C485.277 290.447 492.777 298.581 500.573 304.604",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.622 181.665C415.622 181.665 404.097 194.936 404.35 190.925C404.603 186.914 403.351 186.914 407.108 183.917",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.701 129.934C483.701 129.934 469.643 138.307 468.447 140.995C467.251 143.683 466.66 150.269 465.154 151.76C463.663 153.252 454.994 155.349 455.29 157.446C455.585 159.543 458.878 165.819 458.878 165.819C458.878 165.819 458.287 185.859 458.287 187.35C458.287 188.842 460.074 189.743 461.875 190.038C463.663 190.334 467.856 191.53 467.856 191.53V196.315C467.856 196.315 479.521 200.199 480.717 200.199C481.914 200.199 489.681 200.79 489.681 200.79C489.681 200.79 505.526 190.32 510.606 175.374C515.686 160.429 510.606 148.763 504.921 141.881C499.236 135 483.687 129.919 483.687 129.919L483.701 129.934Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.093 170.308C486.093 170.308 495.957 162.23 498.349 168.817C500.742 175.388 498.645 178.977 495.662 180.173C492.678 181.369 485.502 183.762 485.502 183.762C485.502 183.762 478.621 199.608 478.03 206.194C477.439 212.78 473.245 217.86 475.342 222.335C477.439 226.824 480.422 228.612 495.071 230.103C509.719 231.595 526.408 229.442 536.878 224.953C547.347 220.463 545.898 204.674 543.815 201.085C541.718 197.497 531.854 184.944 532.15 178.358C532.445 171.786 541.423 161.653 535.048 143.429C529.42 127.33 501.938 117.353 494.466 118.253C486.993 119.154 480.408 118.253 480.408 123.038C480.408 127.823 480.703 132.607 485.783 139.179C490.863 145.751 487.88 150.846 486.684 152.042C485.488 153.238 481.604 157.122 482.195 161.907C482.786 166.692 486.079 170.28 486.079 170.28L486.093 170.308Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.813 172.081C468.813 172.081 467.772 176.571 460.862 175.191",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.302 148.242C473.302 148.242 472.612 144.963 469.151 144.963",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.363 152.098C466.688 153.463 466.547 154.772 467.054 155.039C467.56 155.293 468.531 154.392 469.221 153.027C469.91 151.662 470.037 150.353 469.53 150.086C469.024 149.818 468.053 150.733 467.363 152.098Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.791 138.166C181.791 138.166 182.565 136.618 180.243 134.282C177.922 131.946 167.565 125.487 164.455 123.418C161.345 121.349 157.729 114.876 145.303 122.377C132.878 129.877 124.604 143.345 123.042 152.914C121.494 162.484 127.7 174.136 139.351 180.609C151.002 187.083 160.051 188.11 160.051 188.11L161.345 190.446L198.086 185.014C198.086 185.014 204.039 178.808 203.265 175.177C202.491 171.547 196.018 159.388 196.018 159.388C196.018 159.388 200.155 153.182 198.86 151.366C197.566 149.551 181.777 138.166 181.777 138.166H181.791Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.524 169.478C166.524 169.478 161.345 171.293 159.277 172.067C157.208 172.841 151.256 171.026 148.667 165.861C146.077 160.697 149.961 155.25 152.804 154.73C155.646 154.209 157.982 156.024 159.53 155.771C161.078 155.518 161.078 153.702 161.345 152.154C161.598 150.606 157.208 147.75 157.208 147.75C157.208 147.75 163.16 141.276 164.708 138.434C166.256 135.591 154.098 132.734 153.578 130.412C153.057 128.09 164.441 123.418 164.441 123.418C161.331 121.349 157.715 114.876 145.289 122.377C132.864 129.877 124.59 143.345 123.028 152.914C121.48 162.484 127.686 174.136 139.337 180.609C146.964 184.845 153.465 186.745 157.053 187.561L159.783 186.042C159.783 186.042 161.078 184.494 164.188 179.835C167.297 175.177 166.524 169.478 166.524 169.478Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.99 137.125C179.99 137.125 176.627 136.604 174.038 141.262",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.032 164.552C196.032 164.552 191.121 166.621 184.648 160.936",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.369 144.71C182.27 146.497 182.382 148.256 181.608 148.65C180.849 149.03 179.498 147.904 178.597 146.117C177.697 144.33 177.584 142.571 178.358 142.177C179.118 141.797 180.469 142.923 181.369 144.71Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.669 187.336C192.669 187.336 161.88 184.747 160.065 188.11C158.249 191.474 158.517 198.2 158.517 198.2L192.416 190.432L192.669 187.322V187.336Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.778 172.785C242.778 172.785 305.721 104.096 306.101 103.097C306.481 102.098 308.381 79.905 308.578 78.371C308.761 76.823 308.268 74.4307 310.126 72.0383C311.983 69.66 315.515 64.0872 315.515 64.0872C315.515 64.0872 318.315 58.1767 319.244 56.9805C320.173 55.7843 322.481 53.983 323.972 52.3365C325.478 50.69 327.715 49.3953 328.911 50.3241C330.108 51.2529 330.67 55.137 330.67 55.137C330.67 55.137 332.246 55.1651 332.725 57.5716C333.217 59.978 329.348 72.5449 329.193 73.8256C329.038 75.1062 327.87 86.9554 326.477 94.0903C325.098 101.225 322.931 106.179 320.792 108.782C318.653 111.386 295.871 144.611 290.144 150.958C284.417 157.305 261.789 196.723 261.789 196.723L242.792 172.785H242.778Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.967 66.9299C313.967 66.9299 310.829 75.7113 310.689 76.9075C310.548 78.1037 309.746 84.7319 309.746 84.7319",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.806 55.7843C320.806 55.7843 316.739 67.141 316.289 68.9142C315.825 70.6873 315.417 73.0797 315.417 73.0797",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.656 55.151C330.656 55.151 329.432 59.1618 327.603 63.2147C325.773 67.2677 324.127 74.7684 324.085 75.1202",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.519 50.9855C326.519 50.9855 321.749 63.1162 321.073 65.7197C320.398 68.3231 319.483 72.8545 319.16 73.4315",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.117 215.454L264.421 321.013L255.809 333.073L246.761 316.158L239.64 280.104L226.117 215.454Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.502 293.318C143.502 293.318 139.703 308.517 142.334 310.571C144.966 312.612 168.944 319.93 169.521 319.057C170.112 318.185 169.816 308.531 169.225 305.899C168.634 303.267 164.258 299.763 164.258 299.763L143.502 293.332V293.318Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.214 249.172C150.214 249.172 142.616 287.773 143.193 289.237C143.784 290.7 163.372 293.037 163.372 293.037L150.214 249.172Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.743 281.919C141.743 281.919 139.407 294.205 142.334 295.668C145.261 297.132 162.795 301.804 164.258 299.763C165.721 297.723 163.667 288.941 163.667 288.941C163.667 288.941 143.207 279.583 141.743 281.919Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.191 570.227C223.191 570.227 232.717 577.362 235.433 578.052C238.149 578.727 247.675 581.795 248.689 583.498C249.702 585.201 248.689 590.633 247.324 592.673C245.959 594.714 226.582 597.767 217.407 596.754C208.232 595.741 188.166 600.498 186.126 594.038C184.085 587.579 187.491 578.052 187.491 578.052C187.491 578.052 217.069 571.592 223.191 570.227Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.554 590.97C237.811 591.984 222.853 592.673 205.179 593.349C193.921 593.785 188.194 591.604 185.506 589.957C185.549 591.364 185.746 592.758 186.14 594.038C188.18 600.498 208.246 595.741 217.421 596.754C226.596 597.767 245.987 594.714 247.338 592.673C247.872 591.857 248.365 590.506 248.689 589.071C246.282 589.704 243.412 590.464 241.554 590.97Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4163 549.822C98.4163 549.822 90.2547 566.822 91.6196 570.565C92.9846 574.308 97.0654 574.984 100.794 576.349C104.523 577.714 114.05 577.362 116.78 579.065C119.51 580.768 132.414 586.551 138.535 587.565C144.656 588.578 151.115 585.862 151.79 583.146C152.466 580.43 141.926 572.268 137.845 569.552C133.764 566.836 127.306 557.308 127.306 557.308L98.4022 549.822H98.4163Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.01 574.646C104.439 572.831 93.9275 568.327 91.7182 567.356C91.4368 568.749 91.3664 569.875 91.6197 570.565C92.9847 574.308 97.0655 574.984 100.794 576.349C104.538 577.714 114.05 577.362 116.78 579.065C119.51 580.768 132.414 586.551 138.535 587.565C144.656 588.578 151.115 585.862 151.79 583.146C151.931 582.611 151.608 581.837 150.988 580.951C148.146 582.667 144.276 584.652 141.251 584.835C135.805 585.172 120.509 576.672 112.01 574.632V574.646Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.75 334.326C165.75 334.326 158.249 363.175 157.912 371.337C157.574 379.499 158.249 387.662 158.249 387.662C158.249 387.662 152.804 391.743 153.831 395.148C154.844 398.554 156.547 400.932 156.547 400.932C156.547 400.932 143.629 450.229 141.926 452.621C140.223 455.014 122.212 482.878 117.441 492.405C112.685 501.932 101.456 541.674 101.456 541.674C101.456 541.674 99.0777 544.052 98.74 546.43C98.4023 548.808 97.7268 552.89 97.7268 552.89C97.7268 552.89 101.47 560.376 111.672 561.727C121.874 563.092 127.306 561.052 127.306 561.052C127.306 561.052 129.008 558.673 129.684 555.268C130.359 551.862 131.386 546.43 131.386 546.43L150.425 513.444L182.045 455.337L191.571 428.135C191.571 428.135 195.99 468.256 195.652 469.959C195.314 471.662 186.477 502.228 186.477 517.187C186.477 532.146 187.49 563.43 187.49 563.43C187.49 563.43 184.775 568.187 185.45 570.917L186.125 573.633L187.49 578.052C187.49 578.052 200.746 577.714 206.867 576.687C212.988 575.673 223.19 570.227 223.19 570.227C223.19 570.227 224.204 565.471 223.19 563.768C222.177 562.065 220.812 560.362 220.475 558.673C220.137 556.971 219.11 552.89 220.137 548.133C221.15 543.376 231.69 471.999 235.771 453.986C239.851 435.959 240.865 377.825 240.527 367.284C240.189 356.744 238.824 349.257 238.824 349.257L239.5 337.014C239.5 337.014 220.461 328.852 204.137 327.838C187.814 326.825 168.1 329.879 168.1 329.879L165.736 334.34L165.75 334.326Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.194 389.364L184.775 409.77L190.206 425.742",
    stroke: "#8F8F8F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.497 388.83C197.875 386.719 200.225 384.453 201.084 383.595C202.786 381.892 205.165 358.432 205.502 357.419",
    stroke: "#8F8F8F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.492 360.459C170.492 360.459 170.492 378.134 172.532 381.878C174.573 385.621 187.828 393.783 189.869 393.094",
    stroke: "#8F8F8F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.235 352.649C174.235 352.649 192.598 349.595 204.489 353.662",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.659 442.981C220.109 452.959 220.517 467.004 219.447 470.634C217.745 476.418 216.732 477.432 215.704 480.162C214.691 482.878 216.042 485.945 215.367 487.648C214.691 489.351 212.651 519.242 210.948 527.052C209.245 534.876 208.908 551.876 208.908 551.876",
    stroke: "#8F8F8F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.569 342.108C225.569 342.108 223.19 372.027 222.163 381.554C221.15 391.081 217.745 405.689 218.082 411.81C218.42 417.932 219.096 432.554 219.096 432.554C219.096 432.554 219.18 433.862 219.293 436.015",
    stroke: "#8F8F8F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.597 556.281V564.106C209.597 564.106 212.313 564.781 211.638 567.511C210.962 570.227 208.584 572.268 208.584 572.268",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.503 198.2C158.503 198.2 147.372 210.359 144.529 224.333C141.687 238.308 151.256 257.207 151.256 257.207L167.298 316.468C167.298 316.468 162.64 320.084 162.386 323.194C162.133 326.304 163.428 333.552 165.75 334.326C168.086 335.1 204.306 334.847 204.306 334.847C204.306 334.847 240.274 341.32 241.048 341.32C241.821 341.32 245.959 337.703 245.959 333.552C245.959 329.4 245.185 323.462 244.917 320.872C244.65 318.283 234.307 250.227 233.266 245.569C232.225 240.911 231.859 222.504 231.859 222.504L253.529 206.419L257.23 201.648L240.654 174.882C240.654 174.882 214.1 181.369 212.806 182.411C211.511 183.452 158.46 198.2 158.46 198.2H158.503Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.574 178.062C234.574 178.062 252.094 209.895 253.149 209.768C254.205 209.641 263.942 202.464 264.632 200.987C265.335 199.509 264.167 196.244 264.167 196.244C264.167 196.244 245.944 172.405 244.298 170.899C242.652 169.393 240.766 169.956 240.119 170.913C239.471 171.87 233.378 172.701 234.56 178.062H234.574Z",
    fill: "#2563EB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.887 222.504L197.805 247.947",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.008 286.183C190.249 289.237 188.433 292.066 186.562 294.514",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.541 245.006C209.541 245.006 205.39 260.768 194.301 282.003",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2 287.436C197.2 287.436 184.606 306.321 178.71 311.43",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 655,
    height: 606,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginVactor);
export default __webpack_public_path__ + "static/media/login-vactor.cf8cd03e6036dbec6bbba1447687a4c1.svg";
export { ForwardRef as ReactComponent };